import React, { useEffect } from 'react';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {
  FaBuilding,
  FaEnvelope,
  FaPhone,
  FaIdCard,
  FaGlobe,
  FaFingerprint,
  FaTools,
  FaFileContract,
  FaUsers,
  FaKey,
  FaLock,
  FaExternalLinkAlt
} from 'react-icons/fa';

const Formulario = ({ companies }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const { permissionSGU } = user;

    if (permissionSGU?.companyData?.read !== true) {
      navigate("/home");
    }
  }, [navigate]);

  // Função para formatar o CNPJ
  const formatCNPJ = (cnpj) => {
    if (!cnpj) return '--';
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
  };

  return (
    <Row className="g-2">
      {companies?.length > 0 ? (
        companies.map((company, index) => (
          <Col xs={12} key={index}>
            <Card
              className="border-0 shadow-sm overflow-hidden"
              style={{
                borderRadius: '12px',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              }}
            >
              <Card.Header
                className="py-3"
                style={{
                  background: 'linear-gradient(to right, rgba(28, 66, 32, 0.95), rgba(143, 173, 21, 0.9))',
                  borderBottom: 'none',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <div
                      className="d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: '36px',
                        height: '36px',
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '8px',
                      }}
                    >
                      <FaBuilding size={18} className="text-white" />
                    </div>
                    <h5 className="text-white mb-0 fw-bold" style={{ letterSpacing: '0.5px' }}>
                      {company.name?.toUpperCase() || 'Empresa sem nome'}
                    </h5>
                  </div>
                  <div
                    className="position-absolute"
                    style={{
                      right: '-20px',
                      top: '-10px',
                      width: '80px',
                      height: '80px',
                      background: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: '50%',
                      zIndex: 0
                    }}
                  />
                </div>
              </Card.Header>

              <Card.Body className="p-4">
                <Row className="g-4">
                  <Col md={6} lg={4}>
                    <div className="mb-4">
                      <h5 className="mb-3 pb-2 fw-bold" style={{
                        color: '#1c4220',
                        borderBottom: '2px solid rgba(143, 173, 21, 0.4)'
                      }}>
                        Informações de Contato
                      </h5>

                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(28, 66, 32, 0.1)',
                            boxShadow: '0 2px 6px rgba(28, 66, 32, 0.1)'
                          }}
                        >
                          <FaEnvelope className="text-success" style={{ color: '#1c4220' }} />
                        </div>
                        <div>
                          <div className="text-muted small fw-medium">E-mail</div>
                          <div className="fw-medium">{company?.email || '--'}</div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(28, 66, 32, 0.1)',
                            boxShadow: '0 2px 6px rgba(28, 66, 32, 0.1)'
                          }}
                        >
                          <FaPhone className="text-success" style={{ color: '#1c4220' }} />
                        </div>
                        <div>
                          <div className="text-muted small fw-medium">Telefone</div>
                          <div className="fw-medium">{company?.fone || '--'}</div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(28, 66, 32, 0.1)',
                            boxShadow: '0 2px 6px rgba(28, 66, 32, 0.1)'
                          }}
                        >
                          <FaIdCard className="text-success" style={{ color: '#1c4220' }} />
                        </div>
                        <div>
                          <div className="text-muted small fw-medium">CNPJ</div>
                          <div className="fw-medium">{formatCNPJ(company?.cnpj) || '--'}</div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(28, 66, 32, 0.1)',
                            boxShadow: '0 2px 6px rgba(28, 66, 32, 0.1)'
                          }}
                        >
                          <FaGlobe className="text-success" style={{ color: '#1c4220' }} />
                        </div>
                        <div>
                          <div className="text-muted small fw-medium">Domínio de e-mail</div>
                          <div className="fw-medium">{company?.dominioEmail || '--'}</div>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col md={6} lg={4}>
                    <div className="mb-4">
                      <h5 className="mb-3 pb-2 fw-bold" style={{
                        color: '#1c4220',
                        borderBottom: '2px solid rgba(143, 173, 21, 0.4)'
                      }}>
                        Informações do Sistema
                      </h5>

                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(28, 66, 32, 0.1)',
                            boxShadow: '0 2px 6px rgba(28, 66, 32, 0.1)'
                          }}
                        >
                          <FaFingerprint className="text-success" style={{ color: '#1c4220' }} />
                        </div>
                        <div>
                          <div className="text-muted small fw-medium">ID da empresa</div>
                          <div className="fw-medium" style={{ fontSize: '0.85rem', wordBreak: 'break-all' }}>{company?._id || '--'}</div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(28, 66, 32, 0.1)',
                            boxShadow: '0 2px 6px rgba(28, 66, 32, 0.1)'
                          }}
                        >
                          <FaTools className="text-success" style={{ color: '#1c4220' }} />
                        </div>
                        <div>
                          <div className="text-muted small fw-medium">Equipamentos</div>
                          <div className="fw-medium">
                            <Badge
                              bg="success"
                              pill
                              style={{
                                fontSize: '0.9rem',
                                padding: '0.35em 0.8em',
                                background: 'linear-gradient(135deg, #1c4220, #8fad15)'
                              }}
                            >
                              {company?.equipments?.length || 0}
                            </Badge>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(28, 66, 32, 0.1)',
                            boxShadow: '0 2px 6px rgba(28, 66, 32, 0.1)'
                          }}
                        >
                          <FaFileContract className="text-success" style={{ color: '#1c4220' }} />
                        </div>
                        <div>
                          <div className="text-muted small fw-medium">Contrato</div>
                          <div className="fw-medium">{company?.ncontract || '--'}</div>
                        </div>
                      </div>

                      <div className="d-flex align-items-center">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(28, 66, 32, 0.1)',
                            boxShadow: '0 2px 6px rgba(28, 66, 32, 0.1)'
                          }}
                        >
                          <FaUsers className="text-success" style={{ color: '#1c4220' }} />
                        </div>
                        <div>
                          <div className="text-muted small fw-medium">Membros</div>
                          <div className="fw-medium">
                            <Badge
                              bg="primary"
                              pill
                              style={{
                                fontSize: '0.9rem',
                                padding: '0.35em 0.8em',
                                background: 'linear-gradient(135deg, #1c4220, #8fad15)'
                              }}
                            >
                              {company?.members?.length || 0}
                            </Badge>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col md={12} lg={4}>
                    <div>
                      <h5 className="mb-3 pb-2 fw-bold" style={{
                        color: '#1c4220',
                        borderBottom: '2px solid rgba(143, 173, 21, 0.4)'
                      }}>
                        Acesso à API
                      </h5>

                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(28, 66, 32, 0.1)',
                            boxShadow: '0 2px 6px rgba(28, 66, 32, 0.1)'
                          }}
                        >
                          <FaExternalLinkAlt className="text-success" style={{ color: '#1c4220' }} />
                        </div>
                        <div>
                          <div className="text-muted small fw-medium">Acesso API externa</div>
                          <div className="fw-medium">
                            <Badge
                              bg={company?.accessSecretOnlyKey ? "success" : "danger"}
                              pill
                              style={{
                                fontSize: '0.9rem',
                                padding: '0.35em 0.8em',
                                background: company?.accessSecretOnlyKey
                                  ? 'linear-gradient(135deg, #1c4220, #8fad15)'
                                  : 'linear-gradient(135deg, #dc3545, #ff6b6b)'
                              }}
                            >
                              {company?.accessSecretOnlyKey ? "Ativo" : "Inativo"}
                            </Badge>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex align-items-start">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center me-3 flex-shrink-0"
                          style={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: 'rgba(28, 66, 32, 0.1)',
                            marginTop: '4px',
                            boxShadow: '0 2px 6px rgba(28, 66, 32, 0.1)'
                          }}
                        >
                          <FaKey className="text-success" style={{ color: '#1c4220' }} />
                        </div>
                        <div style={{ flex: 1 }}>
                          <div className="text-muted small fw-medium">KEY API externa</div>
                          <div
                            className="p-3 mt-2 rounded"
                            style={{
                              backgroundColor: 'rgba(143, 173, 21, 0.1)',
                              wordBreak: 'break-all',
                              fontSize: '0.85rem',
                              border: '1px solid rgba(28, 66, 32, 0.1)',
                              boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)'
                            }}
                          >
                            {company?.secretOnlyKey ? (
                              <code className="d-flex align-items-center">
                                <FaLock className="me-2" style={{ color: '#1c4220' }} size={14} />
                                <span style={{ color: '#1c4220', fontFamily: 'monospace' }}>{company.secretOnlyKey}</span>
                              </code>
                            ) : (
                              <span className="text-muted fst-italic">Chave não disponível</span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        ))
      ) : (
        <Col xs={12}>
          <div
            className="text-center p-5 rounded-3"
            style={{
              borderRadius: '12px',
              background: 'linear-gradient(135deg, rgba(28, 66, 32, 0.05), rgba(143, 173, 21, 0.1))',
              border: '1px dashed rgba(28, 66, 32, 0.2)'
            }}
          >
            <FaBuilding size={48} style={{ color: '#1c4220', opacity: 0.6 }} className="mb-3" />
            <h5 style={{ color: '#1c4220' }}>Nenhuma empresa cadastrada.</h5>
            <p className="text-muted mb-0">Adicione empresas para visualizá-las aqui.</p>
          </div>
        </Col>
      )}
    </Row>
  );
};

export default Formulario;
